module.exports = __webpack_public_path__ + "static/ephixis_bow_of_nylea-f107b9fe24765a5e91632c9849ed10dc.jpeg";